import { Box, Switch, Typography } from "@mui/material";
import { isNil } from "lodash";
import React from "react";
import TextInput from "../TextInput";

const RowInput = ({
  label,
  description,
  checked,
  value,
  type,
  onChange,
  children,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 1.75,
      gap: 3,
    }}
  >
    <Box>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, color: "text.primary" }}
      >
        {label}
      </Typography>
      {description && (
        <Typography
          variant="caption"
          sx={{ color: "text.secondary", mt: 0.25, display: "block" }}
        >
          {description}
        </Typography>
      )}
    </Box>
    {type === "switch" && (
      <Switch checked={checked} onChange={onChange} size="small" />
    )}
    {type === "text" && (
      <TextInput fullWidth={false} value={value} onChange={onChange} />
    )}
    {children}
  </Box>
);

// const RowInputToggle = ({ label, description, checked, onChange }) => (
//   <Box
//     sx={{
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       py: 1.75,
//     }}
//   >
//     <Box>
//       <Typography
//         variant="body2"
//         sx={{ fontWeight: 600, color: "text.primary" }}
//       >
//         {label}
//       </Typography>
//       {description && (
//         <Typography
//           variant="caption"
//           sx={{ color: "text.secondary", mt: 0.25, display: "block" }}
//         >
//           {description}
//         </Typography>
//       )}
//     </Box>
//     <Switch checked={checked} onChange={onChange} size="small" />
//   </Box>
// );
export default RowInput;
